import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';
import makeAction from 'utils/makeAction';
import parseCatch from 'utils/parseCatch';

import {
  ACCESS_MANAGEMENT,
  ACCESS_MANAGEMENT_NOTES,
} from './Api';


export const ACCESS_MANAGEMENT_REDUCER_NAME = 'accessManagmentAdmin';

export const ACCESS_MANAGEMENT_STATUS = {
  revoked: 'REVOKED',
  granted: 'GRANTED',
};

const GET_ADMINS = 'GET_ADMINS';
const SET_STATUS = 'SET_STATUS';
const ADD_NEW_ADMIN = 'ADD_NEW_ADMIN';
const UPDATE_ADMIN = 'UPDATE_ADMIN';
const GET_ADMINS_DETAILS = 'GET_ADMINS_DETAILS';

const initialState = Immutable.fromJS({
  adminsList: [],
  updateAdminFLag: false,
  amStatus: ACCESS_MANAGEMENT_STATUS.granted,
  adminsDetails: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ADMINS:
      return state.set('adminsList', Immutable.fromJS(action.admins));
    case SET_STATUS:
      return state.set('amStatus', Immutable.fromJS(action.status));
    case GET_ADMINS_DETAILS:
      return state.set('adminsDetails', Immutable.fromJS(action.details));
    case ADD_NEW_ADMIN:
      return state;
    case UPDATE_ADMIN:
      return state.set('updateAdminFLag', Immutable.fromJS(action.updateFlag));
    default:
      return state;
  }
}

const adminsList = (state) =>
  state[ACCESS_MANAGEMENT_REDUCER_NAME].get('adminsList');
const accessManagementStatus = (state) =>
  state[ACCESS_MANAGEMENT_REDUCER_NAME].get('amStatus');
const adminsDetails = (state) =>
  state[ACCESS_MANAGEMENT_REDUCER_NAME].get('adminsDetails');
const updateAdminFLag = (state) => state[ACCESS_MANAGEMENT_REDUCER_NAME].get('updateAdminFLag');

const setAdmins = makeAction(GET_ADMINS, 'admins');
const setStatus = makeAction(SET_STATUS, 'status');
const addNewAdmin = makeAction(ADD_NEW_ADMIN, 'newAdmin');
const setAdminsDetails = makeAction(GET_ADMINS_DETAILS, 'details');
const updateAFlag = makeAction(UPDATE_ADMIN, 'updateFlag');

const getNotes = (user, currUserid) => {
  const params = new URLSearchParams();
  params.append('accessId', currUserid);
  const headers = {
    username: user.username,
    accessHash: user.accessHash,
  };

  return (dispatch) => {
    ApiService.get(ACCESS_MANAGEMENT_NOTES, {
      params,
      headers,
      withCredentials: false,
    }).then((res) => {
      dispatch(
        setAdminsDetails(
          res.data.sort(
            (first, second) =>
              Date.parse(second.createdAt) - Date.parse(first.createdAt)
          )
        )
      );
    }).catch((error) => logger.warn({ msg: 'error fetch admins details:', error }));
  };
};

const getAdmins = (user, status) => {
  const params = new URLSearchParams();
  params.append('status', status);
  const headers = {
    username: user.username,
    accessHash: user.accessHash,
  };

  return (dispatch) =>
    ApiService.get(ACCESS_MANAGEMENT, {
      params,
      headers,
      withCredentials: false,
    })
      .then((res) => {
        dispatch(setAdmins(res.data));
      }
      ).catch((error) => {
        parseCatch(error, true);
      });
};

const addAdmin = (username, user) => {
  const headers = {
    username: user.username,
    accessHash: user.accessHash,
  };

  return (dispatch) =>
    ApiService.post(ACCESS_MANAGEMENT, {
      data: { username },
      headers,
      withCredentials: false,
    })
      .then((response) => {
        dispatch(addNewAdmin(response));
        // eslint-disable-next-line no-alert
        alert('Admin is successfully added.');
      })
      // eslint-disable-next-line no-alert
      .catch(() => alert('Error occurred.'));
};

const updateAdmin = (userId, username, user, status, adminFlag) => {
  const url = `${ACCESS_MANAGEMENT}/${userId}`;
  const data = { username };
  const params = new URLSearchParams();
  params.append('status', status);
  const headers = {
    username: user.username,
    accessHash: user.accessHash,
  };

  return (dispatch) =>
    ApiService.patch(url, {
      headers,
      params,
      data,
      withCredentials: false,
    }).then(() => {
      dispatch(updateAFlag(!adminFlag));
      // eslint-disable-next-line no-alert
      alert(`User is ${status}`);
      // eslint-disable-next-line no-alert
    }).catch(() => alert('Error occurred.'));
};

const setAMStatus = (status) => (dispatch) => {
  dispatch(setStatus(status));
};

export const selector = createStructuredSelector({
  adminsList,
  accessManagementStatus,
  adminsDetails,
  updateAdminFLag,
});

export const actionCreators = {
  getAdmins,
  setAMStatus,
  addAdmin,
  getNotes,
  updateAdmin,
};
